// extracted by mini-css-extract-plugin
module.exports = {"error-panel":"_2gU0_924VL6mZpEWnLN_OI","error-panel__dismiss":"_2UdSLo6EpFXdtYV6nrnk-z"};